import React from 'react';
import { UserStatus } from '../../types/auth';

interface StatusBadgeProps {
    status: UserStatus | string;
    text?: string;
    className?: string;
    size?: 'sm' | 'md' | 'lg';
}

const statusConfig = {
    [UserStatus.DRAFT]: {
        label: 'Черновик',
        className: 'status-draft'
    },
    [UserStatus.PENDING_MODERATION]: {
        label: 'Ожидает модерацию',
        className: 'status-pending'
    },
    [UserStatus.NEEDS_REVISION]: {
        label: 'На доработке',
        className: 'status-needs-revision'
    },
    [UserStatus.APPROVED]: {
        label: 'Подтверждён',
        className: 'status-approved'
    },
    [UserStatus.ACTIVE]: {
        label: 'Активен',
        className: 'status-active'
    },
    [UserStatus.VERIFIED]: {
        label: 'Верифицирован',
        className: 'status-verified'
    },
    [UserStatus.REJECTED]: {
        label: 'Отклонён',
        className: 'status-rejected'
    },
    [UserStatus.BLOCKED]: {
        label: 'Заблокирован',
        className: 'status-blocked'
    },
    [UserStatus.DELETED]: {
        label: 'Удалён',
        className: 'status-deleted'
    }
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, text, className = '', size = 'md' }) => {
    const config = statusConfig[status as UserStatus];

    // If custom text is provided, use it; otherwise use config label
    const displayText = text || (config ? config.label : status);
    const statusClass = config ? config.className : 'status-default';

    const sizeClass = {
        sm: 'text-xs px-2 py-0.5',
        md: 'text-sm px-2.5 py-1',
        lg: 'text-base px-3 py-1.5'
    }[size];

    return (
        <span className={`${statusClass} ${sizeClass} ${className}`}>
            {displayText}
        </span>
    );
};
